<template>
  <div class="step-two">
    <div class="w-item">
      <div class="title-container">
        <div class="title">饮食分析</div>
        <div class="switch-container" v-if="dietData.is_open_ai_comment">
          <!-- <van-switch
            :value="isOpenAiComment"
            @input="bindSwitchChange"
            active-color="#6236ff"
            size="18px"
          /> -->
          <div
            class="loading-ai-btn"
            :class="{ 'loading-ai-btn-rotate': isLoadingAiComment }"
            @click="bindSwitchChange"
            ><span class="iconfont icon-31shuaxin"></span
          ></div>
          <!-- <van-button :loading="isLoadingAiComment" class="loading-ai-btn" color="rgba(0,0,0,0)" size="mini" round @click="bindSwitchChange" ><span class="iconfont icon-31shuaxin" style="font-size: 14px;color:rgba(0,0,0,0.8)"></span></van-button> -->
          <span class="ai-text">AI点评</span>
        </div>
      </div>
      <div class="review-list">
        <div
          class="review-item"
          v-for="(reviewitem, reviewindex) in data.reviewData"
          :key="reviewindex"
        >
          <div class="review-title">{{ reviewitem.name }}</div>
          <MyTextarea
            class="my-textarea"
            :data="reviewitem"
            @replace="bindReplace"
          ></MyTextarea>
        </div>
      </div>
    </div>
    <div class="w-item">
      <div class="title">未来饮食建议</div>
      <MyTextarea class="my-advice" :data="data.dietaryAdvice"></MyTextarea>
    </div>
    <div class="w-item" v-if="data.exceptionDesc">
      <div class="title">
        异常描述<span class="desc">仅作记录，学员看不见</span>
      </div>
      <MyTextarea class="my-textarea" :data="data.exceptionDesc"></MyTextarea>
    </div>
    <div class="w-item">
      <div class="title">饮食特点</div>
      <div class="type-list">
        <div
          class="type-item"
          v-for="(typeitem, typeindex) in labelData"
          :key="typeindex"
        >
          <div class="type-title">{{ typeitem.name }}</div>
          <div class="tag-list">
            <div
              class="tag-item"
              :class="{ 'tag-item-active': tagitem.checked }"
              @click="bindClick(typeitem.list, tagitem, typeitem.name)"
              v-for="(tagitem, tagindex) in typeitem.list"
              :key="tagindex"
            >
              {{ tagitem.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyTextarea from './textarea.vue'
export default {
  components: {
    MyTextarea
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    labelData: {
      type: Array,
      default: () => []
    },
    dietData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      limitObj: {
        优点: 4,
        缺点: 6,
        特点: 6,
        '特殊营养素(仅作记录，不会展示在会员端)': 4
      },
      isOpenAiComment: true,
      AiCommentData: null,
      isLoadingAiComment: false
    }
  },
  computed: {
    disabledAiComment() {
      return this
    }
  },
  watch: {},
  created() {},
  methods: {
    //换一句
    bindReplace(val) {
      if (this.$parent.getReviewData) {
        let type = 1
        switch (val) {
          case 'opening_words':
            type = 1
            break
          case 'end_words':
            type = 2
            break
        }
        this.$parent.getReviewData(type, val)
      }
    },
    bindClick(list, item, name) {
      if (item.checked) {
        item.checked = !item.checked
      } else {
        let count = 0
        list.map((listitem) => {
          if (listitem.checked) {
            count++
          }
        })
        //如果加了限制数量则提示没有限制数量则不限制
        if (this.limitObj[name] === undefined || count < this.limitObj[name]) {
          item.checked = !item.checked
        } else {
          this.$toast('该标签选择不能超过' + this.limitObj[name] + '个')
        }
      }
    },
    //填充ai评论
    async fillAiComment(isCover = false) {
      if (this.AiCommentData) {
        this._fillAiComment(this.AiCommentData, isCover)
      } else {
        if (!isCover && this.getIsFillAiComment()) {
          return
        }
        this.isLoadingAiComment = true
        this.$toast.loading({
          message: 'AI点评加载中...',
          forbidClick: true
        })
        let params = {
          group_id: +this.$route.query.id
        }
        let res = await this.$http
          .getApp('api/v1/NutritionServicesComment/aiComment', params)
          .catch(() => {})
        this.$toast.clear()
        this.isLoadingAiComment = false
        if (res) {
          res = res.data
          if (res.code == 200) {
            this.AiCommentData = res.data
            this._fillAiComment(this.AiCommentData, isCover)
          } else {
            if (isCover) {
              this.$dialog.confirm({
                title: '提示',
                message: res.msg
              })
            }
          }
        } else {
          this.$toast('异常错误')
        }
      }
    },
    _fillAiComment(aicommentData, isCover = false) {
      if (!isCover && this.getIsFillAiComment()) {
        return
      }
      if (aicommentData.future_dietary_analysis) {
        this.data.dietaryAdvice.value = aicommentData.future_dietary_analysis
      }
      this.data.reviewData.map((item) => {
        if (aicommentData[item.val]) {
          item.value = aicommentData[item.val]
        }
      })
    },
    getIsFillAiComment() {
      if (this.data.dietaryAdvice.value) {
        return true
      }
      let list = [
        'staple_comment',
        'protein_comment',
        'vegetable_comment',
        'grease_comment'
      ]
      for (let i = 0; i < this.data.reviewData.length; i++) {
        let item = this.data.reviewData[i]
        if (list.includes(item.val) && item.value) {
          return true
        }
      }
      return false
    },
    bindSwitchChange() {
      this.$dialog
        .confirm({
          title: '提醒',
          message:
            '是否使用ai点评<span style="color:red">覆盖</span>当前点评内容？'
        })
        .then(() => {
          this.fillAiComment(true)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.step-two {
  .w-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 16px;
    box-sizing: border-box;
    margin-bottom: 16px;
    .title-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 14px;
      .switch-container {
        display: flex;
        align-items: center;
        .ai-text {
          font-size: 12px;
        }
      }
    }
    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 00.8);
      line-height: 25px;
      .desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
        margin-left: 13px;
      }
    }
    .type-list {
      .type-item {
        .type-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
          margin-bottom: 4px;
        }
        .tag-list {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-bottom: 12px;
          .tag-item {
            height: 32px;
            text-align: center;
            line-height: 32px;
            white-space: nowrap;
            background: #f7f7f7;
            border-radius: 16px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.8);
            padding: 0px 20px;
            margin: 4px 8px 4px 0px;
            box-sizing: border-box;
          }
          .tag-item-active {
            line-height: 28px;
            padding: 0px 18px;
            background: #ffffff;
            border: 2px solid #6236ff;
            color: #6236ff;
          }
        }
      }
    }
    /*  */
    .review-list {
      .review-item {
        .review-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
          margin-bottom: 8px;
        }
      }
    }
    .my-textarea {
      width: 100%;
      background: #f7f7f7;
      border-radius: 8px;
      box-sizing: border-box;
      margin-bottom: 16px;
    }
    .my-advice {
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #f1f1f1;
      box-sizing: border-box;
    }
  }
  .loading-ai-btn {
    width: 30px;
    height: 30px;
    color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-size: 16px;
      font-weight: bold;
      color: #6236ff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .loading-ai-btn-rotate {
    animation: aiRotate 0.7s linear infinite;
  }
}
@keyframes aiRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
